// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OJf-","option":"styles_option__HVQny","active":"styles_active__2d8wb"};